import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
let gaInitialized = false;

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (!measurementId || gaInitialized) {
      return undefined;
    }

    gaInitialized = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', measurementId, { send_page_view: false });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    return undefined;
  }, []);

  useEffect(() => {
    if (!measurementId || !window.gtag) {
      return;
    }

    window.gtag('config', measurementId, {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null;
};

export default GoogleAnalytics;
